import React, { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { setEditId, selectUserById } from "src/store/callrecorder/usersSlice";
import { fetchUser } from "src/actions/callrecorder/usersActions";

import PageLayout from "../_partials/PageLayout";
import SummaryShow from "src/componets/SummaryShow";
import Tabs from "src/componets/Tabs";
import { ButtonEdit } from "src/componets/Buttons";
import Edit from "./Edit";
import SidebarShow from "./_partials/_SidebarShow";
import DevicesListTable from "../Devices/_partials/_ListTable";
import UserNumbersListTable from "../UserNumbers/_partials/_ListTable";
import OrdersListTable from "../Orders/_partials/_ListTable";
import SubscriptionsListTable from "../Subscriptions/_partials/_ListTable";
import UserNumberSubscriptionsListTable from "../UserNumberSubscriptions/_partials/_ListTable";
import CdrsListTable from "../Cdrs/_partials/_ListTable";
import CoinLogsListTable from "../CoinLogs/_partials/_ListTable";
import Icon from "src/componets/Icon";
import usePermissions from "src/hooks/usePermissions";

const Show: React.FC = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const record = useAppSelector(state => id ? selectUserById(state, id) : undefined);
  const { write_callrecorder } = usePermissions();

  useEffect(() => {
    if (id) {
      dispatch(fetchUser(id));
    }
  }, [id, dispatch]);

  function onClickEdit() {
    if (record) {
      dispatch(setEditId(record.id));
    }
  }

  const userFilterParams = useMemo(() => ({ user_id: id }), [id]);

  return (
    <PageLayout className='v-users-show'>
      <div className='v-container-fluid'>
        <div className='o-header'>
          {
            record &&
              <SummaryShow
                icon={<Icon icon="fa-solid fa-user" />}
                title={`User #${id}`}
                subtitle={record.uid ? record.cnumber : undefined}
                createdAt={record.created_at}
                updatedAt={record.updated_at}
                actions={write_callrecorder ? [
                  <ButtonEdit key='button-edit' onClick={onClickEdit} />
                ] : []}
                className='v-mb-15'
              />
          }
        </div>

        <Tabs
          paramsKey='tab'
          defaultActiveKey='user_numbers'
          destroyInactiveTabPane={true}
          items={[
            { label: 'User Numbers', key: 'user_numbers', children: <UserNumbersListTable filterParams={userFilterParams} /> },
            { label: 'UN Subscriptions', key: 'user_number_subscriptions', children: <UserNumberSubscriptionsListTable filterParams={userFilterParams} /> },
            { label: 'Devices', key: 'devices', children: <DevicesListTable filterParams={userFilterParams} /> },
            { label: 'Orders', key: 'orders', children: <OrdersListTable filterParams={userFilterParams} /> },
            { label: 'Subscriptions', key: 'subscriptions', children: <SubscriptionsListTable filterParams={userFilterParams} /> },
            { label: 'CDRs', key: 'cdrs', children: <CdrsListTable filterParams={userFilterParams} limit={25} /> },
            { label: 'Coin Logs', key: 'coin_logs', children: <CoinLogsListTable filterParams={userFilterParams} /> },
          ]}
        />
      </div>

      <Edit />

      <SidebarShow record={record} />
    </PageLayout>
  )
}

export default Show;
